import React from "react";
import Orders from "../orders/Orders";
import Estimates from "../estimates/Estimates";
import FleetSummary from "../fleet/FleetSummary";
import Requests from "../requests/Requests";
import RentalsAdmin from "../rentals/RentalsAdmin";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Icon from "../sub/Icon";
import "./SplitHome.css";

class SplitHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      windowWidth: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  getArrayLength(array) {
    return array && Array.isArray(array) ? array.length : 0;
  }

  getResponsiveIconSize() {
    const { windowWidth } = this.state;
    if (windowWidth < 480)
      return { width: "50px", height: "50px", fontSize: "1.2rem" };
    if (windowWidth < 640)
      return { width: "55px", height: "55px", fontSize: "1.3rem" };
    if (windowWidth < 768)
      return { width: "60px", height: "60px", fontSize: "1.4rem" };
    return { width: "65px", height: "65px", fontSize: "1.5rem" };
  }

  getStatsLayoutColumns() {
    const { windowWidth } = this.state;
    if (windowWidth < 480) return "1fr";
    if (windowWidth < 768) return "repeat(2, 1fr)";
    if (windowWidth < 1024) return "repeat(3, 1fr)";
    return "repeat(auto-fit, minmax(200px, 1fr))";
  }

  renderStatCard(stat, index) {
    const iconSize = this.getResponsiveIconSize();
    const { windowWidth } = this.state;

    // Layout adaptatif selon la taille d'écran
    const isCompactLayout = windowWidth < 640;
    const isStackedLayout = windowWidth < 480;

    return (
      <div
        key={index}
        className={`stat-card ${isCompactLayout ? "compact" : ""} ${isStackedLayout ? "stacked" : ""}`}
      >
        <div className="stat-icon-container">
          <div
            className="stat-icon"
            style={{
              ...iconSize,
              background: stat.color,
            }}
          >
            <Icon icon={stat.icon} style={{ fontSize: iconSize.fontSize }} />
          </div>
        </div>
        <div className="stat-content">
          <div className="stat-number">{stat.value}</div>
          <div className="stat-label">
            <FormattedMessage id={stat.label} />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { windowWidth } = this.state;
    const statsColumns = this.getStatsLayoutColumns();

    // Compteurs pour les statistiques
    const ordersCount = this.getArrayLength(this.props.orders);
    const estimatesCount = this.getArrayLength(this.props.estimates);
    const equipmentsCount = this.getArrayLength(this.props.equipments);
    const requestsCount = this.getArrayLength(this.props.requests);
    const rentalsCount =
      this.props.rentals && this.props.rentals.rentals
        ? this.props.rentals.rentals.length
        : 0;

    // Styles améliorés avec réactivité
    const modernHomepageStyle = {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #86c7ed 0%, #f18a4a 100%)",
      padding: windowWidth < 768 ? "1rem" : "2rem",
    };

    const statsStyle = {
      display: "grid",
      gridTemplateColumns: statsColumns,
      gap: windowWidth < 768 ? "1rem" : "1.5rem",
      marginBottom: windowWidth < 768 ? "1.5rem" : "2rem",
    };

    return (
      <div className="modern-homepage" style={modernHomepageStyle}>
        {/* Stats Overview avec meilleure responsivité */}
        <div className="stats-overview" style={statsStyle}>
          {this.renderStatCard(
            {
              value: ordersCount,
              label: "Orders",
              icon: "shopping-cart",
              color: "linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%)",
            },
            0,
          )}
          {this.renderStatCard(
            {
              value: rentalsCount,
              label: "Rentals",
              icon: "calendar",
              color: "linear-gradient(135deg, #28a745 0%, #5cb85c 100%)",
            },
            1,
          )}
          {this.renderStatCard(
            {
              value: estimatesCount,
              label: "Estimates",
              icon: "file-text",
              color: "linear-gradient(135deg, #f18a4a 0%, #ff9f6b 100%)",
            },
            2,
          )}
          {this.renderStatCard(
            {
              value: equipmentsCount,
              label: "Fleet",
              icon: "truck",
              color: "linear-gradient(135deg, #86c7ed 0%, #a8d5f2 100%)",
            },
            3,
          )}
          {this.renderStatCard(
            {
              value: requestsCount,
              label: "Interventions",
              icon: "wrench",
              color: "linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%)",
            },
            4,
          )}
        </div>

        {/* Dashboard Grid avec CSS Grid Dense Flow - Layout Masonry */}
        <div className="dashboard-section">
          <div className="dashboard-card-item">
            <Card
              className="p-3"
              style={{
                borderRadius: "20px",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
              }}
            >
              <Card.Title>
                <h4
                  style={{
                    color: "#1e3d72",
                    fontSize: windowWidth < 768 ? "1.1rem" : "1.25rem",
                  }}
                >
                  <FormattedMessage id="Summary.Orders" />
                </h4>
              </Card.Title>
              <div className="table-responsive">
                <Orders limit={5} />
              </div>
              <Link to="/home/orders" className="overlay text-center">
                <Icon icon="magnifying-glass" />
              </Link>
            </Card>
          </div>

          <div className="dashboard-card-item">
            <Card
              className="p-3"
              style={{
                borderRadius: "20px",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
              }}
            >
              <Card.Title>
                <h4
                  style={{
                    color: "#b8460e",
                    fontSize: windowWidth < 768 ? "1.1rem" : "1.25rem",
                  }}
                >
                  <FormattedMessage id="Summary.Requests" />
                </h4>
              </Card.Title>
              <div className="table-responsive">
                <Requests limit={5} />
              </div>
              <Link to="/home/requests" className="overlay text-center">
                <Icon icon="magnifying-glass" />
              </Link>
            </Card>
          </div>

          <div className="dashboard-card-item">
            <Card
              className="p-3"
              style={{
                borderRadius: "20px",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
              }}
            >
              <Card.Title>
                <h4
                  style={{
                    color: "#28a745",
                    fontSize: windowWidth < 768 ? "1.1rem" : "1.25rem",
                  }}
                >
                  Synthèse des locations
                </h4>
              </Card.Title>
              <div className="table-responsive">
                <RentalsAdmin limit={5} />
              </div>
              <Link to="/home/rentals/active-rentals" className="overlay text-center">
                <Icon icon="magnifying-glass" />
              </Link>
            </Card>
          </div>

          <div className="dashboard-card-item">
            <Card
              className="p-3"
              style={{
                borderRadius: "20px",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
              }}
            >
              <Card.Title>
                <h4
                  style={{
                    color: "#b8460e",
                    fontSize: windowWidth < 768 ? "1.1rem" : "1.25rem",
                  }}
                >
                  <FormattedMessage id="Summary.Estimates" />
                </h4>
              </Card.Title>
              <div className="table-responsive">
                <Estimates limit={5} />
              </div>
              <Link to="/home/estimates" className="overlay text-center">
                <Icon icon="magnifying-glass" />
              </Link>
            </Card>
          </div>

          <div className="dashboard-card-item">
            <Card
              className="p-3"
              style={{
                borderRadius: "20px",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
              }}
            >
              <Card.Title>
                <h4
                  style={{
                    color: "#1e3d72",
                    fontSize: windowWidth < 768 ? "1.1rem" : "1.25rem",
                  }}
                >
                  <FormattedMessage id="Fleet.Summary" />
                </h4>
              </Card.Title>
              <div className="table-responsive">
                <FleetSummary
                  limit={1}
                  equipments={this.props.equipments || []}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    equipments: state.equipments || [],
    orders: state.orders || [],
    estimates: state.estimates || [],
    requests: state.requests || [],
    rentals: state.rentals || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SplitHome);
